import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { copilotMessagePublisherEnvironment } from '../copilot-message-publisher-environment';
import { messageHistorySchema } from '../schemas/message-history';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Gets the message history for the logged in account
 * @param limit Limits the number of results returned. The default is 25
 * @returns An array of MessageHistory objects
 */
export function getMessages(this: unknown, limit?: number) {
  let url = copilotMessagePublisherEnvironment.resolve(this).messagesUrl;
  if (typeof limit === 'number') {
    url += `?limit=${limit}`;
  }

  return fromFetch(
    new Request(url, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
    })
  ).pipe(selectData(z.array(messageHistorySchema)));
}
